import { createGlobalContext } from "@kivra/react-components";
import { getCopyString } from "@kivra/sdk/copy-consumer";
import type { KnownLanguage } from "@kivra/sdk/types";
import type { Copy, GetCopyArguments } from "../copy";

interface CopyContext {
  copy: Copy;
  setCopy: React.Dispatch<React.SetStateAction<KnownLanguage<"fi">>>;
}

const {
  GlobalContextProvider: CopyContextProvider,
  hookCreator: copyHookCreator,
} = createGlobalContext<CopyContext>();

export { CopyContextProvider };

export const useCopy = copyHookCreator((g) =>
  getCopyString<GetCopyArguments>({ copy: g.copy, debug: false })
);
export const useSetCopy = copyHookCreator((g) => g.setCopy);
